import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSelectedFilterValues } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { Button } from '../../../subcomponents/button/button';
import { Modal } from '../../../subcomponents/modal/modal';
import { getNumberOfFiltersApplied } from '../../../utils/filters/get-number-of-filters-applied';
import { getFilterSections } from '../utils/get-filter-sections';
import { getUpdatedSelectedValuesForFilterKey } from '../utils/get-updated-selected-values-for-filter-key';
import { updateFilter } from '../utils/update-filter';
import { CompositeFilterAccordion } from './accordion';
import { CompositeFilterModalFooter } from './modal-footer';
const b = bemClassBuilder('v-composite-filter-modal');
export const CompositeFilterModal = observer(props => {
    const { displayText, filter, sectionsToDisplay, cdnOptions } = props;
    const filterKeys = sectionsToDisplay.map(section => section.key);
    const [showModal, setShowModalState] = useState(false);
    const [selectedValues, setSelectedValues] = useState(getSelectedFilterValues(filter));
    const handleOpen = () => {
        setSelectedValues(getSelectedFilterValues(filter));
        setShowModalState(true);
    };
    const handleClose = () => setShowModalState(false);
    const handleClear = () => {
        setSelectedValues({
            genre: [],
            attribute: [],
            event: [],
            category: [],
            subscription: [],
            billingPeriod: [],
            billingRecurrence: []
        });
    };
    const handleApply = () => {
        updateFilter(filter.id, filter.type, filterKeys, selectedValues);
        handleClose();
    };
    const handleChange = (filterKey, filterValue, _, multiselect) => {
        const selectedValuesForFilterKey = getUpdatedSelectedValuesForFilterKey(selectedValues[filterKey], filterValue, multiselect);
        setSelectedValues(Object.assign(Object.assign({}, selectedValues), { [filterKey]: selectedValuesForFilterKey }));
    };
    const numberOfSelectedFilterValues = Object.values(selectedValues).reduce((total, values) => {
        return total + values.length;
    }, 0);
    const tempFilter = {
        id: filter.id,
        type: filter.type,
        sections: getFilterSections(filter, selectedValues),
        baseData: filter.baseData
    };
    const footerProps = {
        filter: tempFilter,
        displayText,
        hasFiltersApplied: numberOfSelectedFilterValues > 0,
        onClear: handleClear,
        onApply: handleApply,
        onCancel: handleClose
    };
    const footer = _jsx(CompositeFilterModalFooter, Object.assign({}, footerProps));
    const numberOfFiltersApplied = getNumberOfFiltersApplied({ id: filter.id, type: filter.type, keys: filterKeys });
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsxs("div", Object.assign({ className: b.element('button-area') }, { children: [_jsx(Button, { onClick: handleOpen, label: displayText.modalTriggerButtonLabel, className: b.element('button'), iconName: props.filterModalButtonIconName }), numberOfFiltersApplied > 0 && (_jsx("div", Object.assign({ className: b.element('filter-count-indicator') }, { children: numberOfFiltersApplied })))] })), _jsx(Modal, Object.assign({ anchoredToTop: props.isAnchoredToTop, show: showModal, className: b.block(), onClose: handleClose, heading: displayText.filterTitleLabel, footer: footer }, { children: _jsx(CompositeFilterAccordion, { filter: tempFilter, sectionsToDisplay: sectionsToDisplay, displayText: displayText, expandAccordionSectionsByDefault: true, onChange: handleChange, cdnOptions: cdnOptions }) }))] })));
});
CompositeFilterModal.displayName = 'CompositeFilterModal';
